import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost';

function classes(variant: Variant, block: boolean, extra?: string): string {
  return [styles.button, styles[variant], block ? styles.block : '', extra]
    .filter(Boolean)
    .join(' ');
}

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  block?: boolean;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  block = false,
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button className={classes(variant, block, className)} {...rest}>
      {children}
    </button>
  );
}

interface ButtonLinkProps {
  to: string;
  variant?: Variant;
  block?: boolean;
  className?: string;
  children: ReactNode;
}

export function ButtonLink({
  to,
  variant = 'primary',
  block = false,
  className,
  children,
}: ButtonLinkProps) {
  return (
    <Link to={to} className={classes(variant, block, className)}>
      {children}
    </Link>
  );
}
